module.exports = __webpack_public_path__ + "assets/img/paidmember.120e3f18.png";